export default __webpack_public_path__ + "static/media/pro-elevate-cbb-banner-2.884e3f3c.jpg";